pnx-coverage-map {
	display: block;
	position: relative;
}

pnx-coverage-map .maplibregl-map {
	position: absolute;
	inset: 0;
	background-color: white;
}
